document.addEventListener('DOMContentLoaded', () => {
  const findAndReplaceText = () => {
    // Add debug counter
    let replacements = 0;
    
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        // Optional: Add filter to skip hidden elements
        acceptNode: (node) => {
          const parent = node.parentElement;
          // Skip hidden elements
          if (parent && (
            getComputedStyle(parent).display === 'none' ||
            getComputedStyle(parent).visibility === 'hidden'
          )) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      },
      false
    );

    let node;
    while (node = walker.nextNode()) {
      if (node.nodeValue.trim().includes('Book Now')) {
        const oldValue = node.nodeValue;
        node.nodeValue = node.nodeValue.replace(
          /Book Now/gi,  // Case insensitive
          'Get a Quote'
        );
        if (oldValue !== node.nodeValue) {
          replacements++;
        }
      }
    }

    // Debug info
    // console.log(`Replaced ${replacements} instances of "Book Now"`);
  };

  // Initial run
  findAndReplaceText();

  // Optional: Run again after dynamic content loads
  // setTimeout(findAndReplaceText, 1000);
});